import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPie = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M28.5104 18C28.2315 18.0048 27.9554 18.0575 27.6944 18.156C25.6483 16.134 22.8876 15 20.0109 15C17.1342 15 14.3735 16.134 12.3274 18.156C12.066 18.0576 11.7897 18.0049 11.5104 18C11.0736 17.9982 10.6439 18.1109 10.2642 18.3268C9.88449 18.5427 9.56797 18.8544 9.34619 19.2307C9.12441 19.607 9.00511 20.0349 9.00016 20.4717C8.99521 20.9085 9.1048 21.3389 9.318 21.7202C9.5312 22.1014 9.84058 22.4202 10.2153 22.6446C10.59 22.8691 11.017 22.9915 11.4538 22.9996C11.8905 23.0076 12.3218 22.9011 12.7045 22.6907C13.0873 22.4802 13.4083 22.1731 13.6354 21.8C13.8567 22.1656 14.1685 22.4678 14.5408 22.6776C14.913 22.8874 15.3331 22.9977 15.7604 22.9977C16.1877 22.9977 16.6078 22.8874 16.98 22.6776C17.3523 22.4678 17.6641 22.1656 17.8854 21.8C18.1067 22.1656 18.4185 22.4678 18.7908 22.6776C19.163 22.8874 19.5831 22.9977 20.0104 22.9977C20.4377 22.9977 20.8578 22.8874 21.23 22.6776C21.6023 22.4678 21.9141 22.1656 22.1354 21.8C22.3567 22.1656 22.6685 22.4678 23.0408 22.6776C23.413 22.8874 23.8331 22.9977 24.2604 22.9977C24.6877 22.9977 25.1078 22.8874 25.48 22.6776C25.8523 22.4678 26.1641 22.1656 26.3854 21.8C26.6126 22.1731 26.9335 22.4802 27.3163 22.6907C27.699 22.9011 28.1303 23.0076 28.567 22.9996C29.0038 22.9915 29.4308 22.8691 29.8055 22.6446C30.1802 22.4202 30.4896 22.1014 30.7028 21.7202C30.916 21.3389 31.0256 20.9085 31.0206 20.4717C31.0157 20.0349 30.8964 19.607 30.6746 19.2307C30.4528 18.8544 30.1363 18.5427 29.7566 18.3268C29.3769 18.1109 28.9472 17.9982 28.5104 18V18Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5104 23L12.2914 29.248C12.3518 29.7318 12.5869 30.1768 12.9525 30.4995C13.318 30.8221 13.7888 31.0001 14.2764 31H25.7444C26.2319 31.0001 26.7027 30.8221 27.0683 30.4995C27.4338 30.1768 27.6689 29.7318 27.7294 29.248L28.5104 23",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0104 9V11",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0104 10V12",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.0104 10V12",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgPie);
export default ForwardRef;
